import { create } from 'apisauce'
import * as fakeApi from './sample.json'

const baseUrlsLib = {
  prod: 'https://ogfviwug00.execute-api.us-east-2.amazonaws.com/prod',
  homolog: 'https://lktzgoiig7.execute-api.us-east-2.amazonaws.com/homolog',
  dev: 'https://hayg11kdwf.execute-api.us-east-2.amazonaws.com/dev',
  default: 'https://hayg11kdwf.execute-api.us-east-2.amazonaws.com/dev',
}

const getBaseUrl = () => {
  if (process.env.REACT_APP_STAGE) {
    return baseUrlsLib[process.env.REACT_APP_STAGE.toLowerCase()]
  }
  return baseUrlsLib.default
}

const baseUrl = getBaseUrl()
const pagImovelBaseUrl = 'https://clientes.pagimovel.com.br'

const localProBaseUrl =
  process.env.REACT_APP_STAGE === 'prod'
    ? 'https://api.localpro.com.br/'
    : 'https://dev.api.localpro.com.br/'

export const cityApi = create({
  baseURL: baseUrl,
  headers: {
    'X-API-KEY': 'rTV9MjnNrg86r6cFRU7O71QWsmUmJ2F83KcglBTy',
  },
})

export const apiWithoutPropertySuffix = create({
  baseURL: `${baseUrl}`,
  headers: {
    'X-API-KEY': 'rTV9MjnNrg86r6cFRU7O71QWsmUmJ2F83KcglBTy',
  },
})

export const pagImovelApi = create({
  baseURL: pagImovelBaseUrl,
  headers: { 'X-API-KEY': 'TbQj7zJWpk2Y1yLyQQvkAaMQB9iUNTo8aak7dAa0' },
})

export default create({
  baseURL: `${baseUrl}/property`,
  headers: {
    'X-API-KEY': 'rTV9MjnNrg86r6cFRU7O71QWsmUmJ2F83KcglBTy',
  },
})

export const getMockData = async data => {
  return Promise.resolve({ data: fakeApi.default[data] })
}

export const localProPostForm = create({
  baseURL: localProBaseUrl,
  headers: {
    'Content-Type': 'multipart/form-data',
    boundary: '---XXX---',
  },
})

export const localProApi = create({
  baseURL: localProBaseUrl,
})

export const requestMockData = create({
  baseURL: `http://localhost:5000`,
})
